/**
 * Root component of `apps/web` — Phase 5.
 *
 * Integrates TanStack Router as the navigation layer inside the
 * data providers (Query + PowerSync).
 */

import { type Component, Suspense } from "solid-js";
import { RouterProvider } from "@tanstack/solid-router";

import { AppProviders } from "@/providers/app-providers";
import { router } from "@/router";

export const App: Component = () => (
  <Suspense fallback={null}>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </Suspense>
);
